import React from 'react'
import LotCategoryGrid from '../components/grids/LotCategoryGrid'

const LotCategorySettingsPage = () => {
    return (
        <div className='stretched row-based container'>
            <LotCategoryGrid />
        </div>
    )
}

export default LotCategorySettingsPage